import styled from 'styled-components';
import { Link } from '@perch-labs/shrike';
import { Container as LayoutContainer } from 'styles';

export const Container = styled(LayoutContainer).attrs({
  alignItems: 'center',
  flex: true,
  wrap: 'wrap-reverse',
})`
  ${props => props.theme.media.xsmall`
    justify-content: center;
  `}
`;

export const AdditionalInfo = styled.div`
  background: ${props => props.theme.colors.background.secondary};
  padding: 24px;

  ${props => props.theme.media.large`
    width: 237px;
  `}

  ${props => props.theme.media.xlarge`
    width: 237px;
  `}

  ${props => props.theme.media.xsmall`
    width: 100%;
  `}
`;

export const LearnMoreLink = styled(Link).attrs({
  type: 'standalone',
})`
  && {
    font-size: ${props => props.theme.fontSizes[400]};
    width: initial;
  }
`;

export const DonutWrapper = styled.div`
  position: relative;
`;

export const EquivalencyStat = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;
